import { render, staticRenderFns } from "./LedgerEntryDetails.vue?vue&type=template&id=4d0b7b98&"
import script from "./LedgerEntryDetails.vue?vue&type=script&lang=js&"
export * from "./LedgerEntryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports